var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.083 21.813a4.897 4.897 0 01-2.065-.454L2 22l.631-3.024a4.904 4.904 0 114.447 2.832",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.612 12.019A6.625 6.625 0 016 9.24C6 5.223 9.598 2 14 2s8 3.223 8 7.24c0 2.374-1.262 4.464-3.199 5.782.001.756-.001 1.775-.001 2.845l-3.139-1.546A8.81 8.81 0 0114 16.48a8.789 8.789 0 01-2.056-.25M4.795 16.965a.05.05 0 11-.07.07.05.05 0 01.07-.07M7.045 16.965a.05.05 0 11-.07.07.05.05 0 01.07-.07M9.295 16.965a.05.05 0 11-.07.07.05.05 0 01.07-.07",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.044c0-.657.406-1.013.813-1.287.398-.268.796-.617.796-1.26a1.609 1.609 0 10-3.218 0M14 12.458a.1.1 0 00-.1.1.1.1 0 00.1.1.1.1 0 00.1-.1.1.1 0 00-.1-.1",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgSupport;